import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { DemandPartnerProfile, SupplyPartnerProfile } from '@shared/api/services/partner.service';

export interface PartnerState {
  supplyPartnerProfiles: Record<string, SupplyPartnerProfile>;
  demandPartnerProfiles: Record<string, DemandPartnerProfile>;
}

const initialState: PartnerState = {
  supplyPartnerProfiles: {},
  demandPartnerProfiles: {}
};

const partnerSlice = createSlice({
  name: 'partner',
  initialState,
  reducers: {
    setSupplyPartnerProfiles: (state, action: PayloadAction<SupplyPartnerProfile[]>) => {
      state.supplyPartnerProfiles = Object.fromEntries(
        action.payload.map((profile) => [profile.spId, profile])
      );
    },
    setDemandPartnerProfiles: (state, action: PayloadAction<DemandPartnerProfile[]>) => {
      state.demandPartnerProfiles = Object.fromEntries(
        action.payload.map((profile) => [profile.dpId, profile])
      );
    },
    setSupplyPartnerProfile: (state, action: PayloadAction<SupplyPartnerProfile>) => {
      state.supplyPartnerProfiles[action.payload.spId] = action.payload;
    },
    setDemandPartnerProfile: (state, action: PayloadAction<DemandPartnerProfile>) => {
      state.demandPartnerProfiles[action.payload.dpId] = action.payload;
    },
    resetPartnerState: () => initialState
  }
});

export const {
  setSupplyPartnerProfiles,
  setDemandPartnerProfiles,
  setSupplyPartnerProfile,
  setDemandPartnerProfile,
  resetPartnerState
} = partnerSlice.actions;

export default partnerSlice.reducer;
